import { DrupalAjaxSettings } from '@nech/types/drupal.library';

export type ComponentArg<T = { [key: string]: any } | undefined> = {
  selector: string;
  shared: T;
  /**
   * Attach function is trigger when the component is attached to the DOM
   * This callback is trigger only once even if there are multiple instances of the component
   */
  attach?: (
    context: HTMLElement,
    options: { settings: DrupalAjaxSettings; empty: boolean },
  ) => void;
  /**
   * Detach function is trigger when the component is detached from the DOM
   * This callback is trigger only once even if there are multiple instances of the component
   */
  detach?: (
    context: HTMLElement,
    options: { settings: DrupalAjaxSettings; empty: boolean },
  ) => void;
  /**
   * Instance mount is trigger when the component is mounted to the DOM
   * This callback is trigger for each instance of the component
   * @returns {() => void} - Function to trigger when the component is destroyed
   */
  instance?: ($el: JQuery<HTMLElement>) => void | (() => void);
};

export const NECH_PROCESSED_CLASS = 'nech-js-processed';

export const drupalComponent = <T>(identifier: string, args: ComponentArg<T>) => {
  (function (Drupal, once) {
    Drupal.behaviors[identifier] = {
      attach: function attach(context, settings) {
        const $els = jQuery(context).find(args.selector).not(`.${NECH_PROCESSED_CLASS}`);
        args.attach?.(context, { settings, empty: !($els.length > 0) });
        $els.each((i, el) => {
          const $el = jQuery(el);
          $el.addClass(NECH_PROCESSED_CLASS);
          const onDestroy = args.instance?.($el);
          // SUA1616-582 : instance() peut se terminer par une expression jQuery.
          // Un test de verite creerait alors un MutationObserver sur tout
          // document.body, et l'appel h() leverait une TypeError le jour ou
          // l'element quitte le DOM. On exige une vraie fonction.
          if (typeof onDestroy === 'function') {
            // trigger an event when $el disapear from the DOM
            const observer = new MutationObserver((mutationsList, observer) => {
              if (!$el[0] || !document.body.contains($el[0])) {
                onDestroy();
                observer.disconnect();
              }
            });
            observer.observe(document.body, {
              childList: true,
              subtree: true,
            });
          }
        });
      },
      detach: function dettach(context, settings) {
        const $els = jQuery(context).find(args.selector);
        args.detach?.(context, { settings, empty: !($els.length > 0) });
      },
    };
  })(Drupal, once);
};
